goog.provide('el8.appchart.dialog.rxDownloadFills');

goog.require('el8.template.appchart.dialog.rxDownloadFills');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.ptdata.medOrderFills');
goog.require('el8.appchart.medsHx.main');
goog.require('el8.app.pageLayout');
goog.require('el8.data.referencedUsers');


el8.appchart.dialog.rxDownloadFills = (function() {

    var summaryItem = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'View all downloaded medication fills',
        modal: false,
        height: function() {
            return el8.app.pageLayout.getAppHeight() - 200;
        },
        width: 570,
        contentFn: el8.template.appchart.dialog.rxDownloadFills.content,
        showXButton: true
    });

    var form = new el8.uiwidget.Form({
        fields: []
    });
    if (el8Globals.FEATURES['MedsHxIgnore']) {
        form.addButton('sign-off-merge', 'Sign Off',
            function() {
                var id = summaryItem.getId();
                form.disable();
                el8.appchart.medsMgr.acknowledgeRxDownloadSummary(id, function() {
                    form.enable();
                    that.hide();
                });
            }, true);
        form.addButton('sign-off', 'Sign Off & Do NOT Add to Med Lists',
            function() {
                var id = summaryItem.getId();
                form.disable();
                el8.appchart.medsMgr.acknowledgeNoMergeRxDownloadSummary(id, function() {
                    form.enable();
                    that.hide();
                });
            }, false);
    } else {
        form.addButton('sign-off-merge', 'Sign Off',
            function() {
                var id = summaryItem.getId();
                form.disable();
                el8.appchart.medsMgr.acknowledgeRxDownloadSummary(id, function() {
                    form.enable();
                    that.hide();
                });
            }, true);
    }
    that.setForm(form);

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        that.getContentElt().on('click', '.fill-detail-trigger',  function(e) {
            var id = $(e.target).attr('data-id')*1;
            var fill = summaryItem.getDownloadedFillById(id);
            if (fill) {
                el8.appchart.medsHx.main.show({threadId: fill.getThreadId()});
            } else {
                UIM && UIM.logError('Strange, displayed downloaded fill is not on rx summary item');
            }
        });
    };

    var super_show = that.show;
    that.show = function(_summaryItem) {
        summaryItem = _summaryItem;
        super_show.call(that);
        that._render();
        if (_summaryItem.isSignedOff()) {
            form.hideButton('sign-off-merge');
            form.hideButton('sign-off');
        } else {
            form.showButton('sign-off-merge');
            form.showButton('sign-off');
        }
        /* Need to adjust height from showing/hiding all buttons */
        that.adjustHeight();
    };

    that._render = function() {
        $('.fills-header', that.getContentElt()).html(
            el8.template.appchart.dialog.rxDownloadFills.header({
                fillCount: summaryItem.getDownloadedFillsCount(),
                reconciledFillCount: summaryItem.getReconciledFillsCount(),
                pbmName: summaryItem.getEligPbmName(),
                signUserName: summaryItem.isSignedOff() ? summaryItem.getSignUserName() : '',
                signDate: summaryItem.isSignedOff() ? el8.service.tz.soyStr(summaryItem.getSignDate()) : ''
            })
        );
        $('.fills-content', that.getContentElt()).html(
            el8.template.appchart.dialog.rxDownloadFills.groupedFills({
                groups: that._extractFills(summaryItem)
            })
        );
    };

    var super_hide = that.hide;
    that.hide = function() {
        summaryItem = null;
        super_hide.call(that);
    };

    /**
     * Helper method for turning an rx summary item into something we can pass
     * into our renderer
     */
    that._extractFills = function(summaryItem) {
        var fills = summaryItem.fetchDownloadedFills(true);
        var byThreadId = {}, threadId = null;
        for (var i=0; i<fills.length; i++) {
            threadId = fills[i].getThreadId();
            if (!byThreadId[threadId]) {
                byThreadId[threadId] = [];
            }
            byThreadId[threadId].push(fills[i]);
        }
        var result = [];
        var sortedFills = [];
        var fillsSortFn = function(a, b) {
            return el8.util.datecompare.cmp(b.getLastFillDate(), a.getLastFillDate());
        };
        var fillsMapFn = function(a) { return a.asSoyMap(); };

        for (var threadId in byThreadId) {
            if (byThreadId.hasOwnProperty(threadId)) {
                sortedFills = byThreadId[threadId].sort(fillsSortFn);
                result.push({
                    threadId: threadId,
                    mostRecentFillDate: sortedFills[0].getLastFillDate(),
                    summaryIsSignedOff: summaryItem.isSignedOff(),
                    fills: sortedFills.map(fillsMapFn)
                });
            }
        }
        return result.sort(function(a, b) {
            return el8.util.datecompare.cmp(b['mostRecentFillDate'], a['mostRecentFillDate']);
        });
    };

    return that;

})();
